import React from 'react';
import styles from './styles.css.js';
export default function VerticalMarkers(_a) {
    var innerHeight = _a.innerHeight, verticalMarkerLeft = _a.verticalMarkerLeft, highlightedPoint = _a.highlightedPoint, isGroupNavigation = _a.isGroupNavigation, scaledSeries = _a.scaledSeries, verticalMarkerRef = _a.verticalMarkerRef, highlightedPointRef = _a.highlightedPointRef;
    var showSinglePoint = highlightedPoint !== null;
    var showAllPoints = highlightedPoint === null;
    return (React.createElement("g", null,
        !isGroupNavigation && verticalMarkerLeft !== null && (React.createElement("line", { className: styles['vertical-marker'], ref: verticalMarkerRef, x1: verticalMarkerLeft, x2: verticalMarkerLeft, y1: 0, y2: innerHeight, key: verticalMarkerLeft })),
        showAllPoints &&
            verticalMarkerLeft !== null &&
            scaledSeries
                .filter(function (_a) {
                var x = _a.x;
                return x === verticalMarkerLeft || isNaN(x);
            })
                .map(function (_a, i) {
                var x = _a.x, y = _a.y, color = _a.color;
                return (React.createElement("circle", { key: i + "-" + x + "-" + y, className: styles['vertical-marker-circle'], cx: verticalMarkerLeft, cy: y, r: 4, stroke: color }));
            }),
        showSinglePoint && highlightedPoint !== null && (React.createElement("circle", { key: highlightedPoint.x + "-" + highlightedPoint.y, className: styles['vertical-marker-circle-active'], cx: highlightedPoint.x, cy: highlightedPoint.y, r: 4, stroke: highlightedPoint.color, fill: highlightedPoint.color, ref: highlightedPointRef }))));
}
//# sourceMappingURL=vertical-marker.js.map